import api from '../utils/api';

export async function listEdgeConnectors() {
  const { data } = await api.get('/edge-connectors/');
  return data;
}

export async function getEdgeConnector(id) {
  const { data } = await api.get(`/edge-connectors/${id}`);
  return data;
}

// A resposta traz o provisioning_token em texto claro uma única vez.
export async function createEdgeConnector(payload) {
  const { data } = await api.post('/edge-connectors/', payload);
  return data;
}

export async function reissueProvisioningToken(id) {
  const { data } = await api.post(`/edge-connectors/${id}/provisioning-token`);
  return data;
}

// A resposta traz o new_client_secret em texto claro uma única vez.
export async function rotateEdgeConnectorSecret(id) {
  const { data } = await api.post(`/edge-connectors/${id}/rotate-secret`);
  return data;
}

export async function abortEdgeConnectorRotation(id) {
  const { data } = await api.post(`/edge-connectors/${id}/abort-rotation`);
  return data;
}

export async function setEdgeConnectorBlocked(id, blocked) {
  const { data } = await api.put(`/edge-connectors/${id}/blocked`, { blocked });
  return data;
}

export async function revokeEdgeConnector(id) {
  const { data } = await api.post(`/edge-connectors/${id}/revoke`);
  return data;
}

export async function deleteEdgeConnector(id) {
  const { data } = await api.delete(`/edge-connectors/${id}`);
  return data;
}

export async function listEdgeConnectorResources(id) {
  const { data } = await api.get(`/edge-connectors/${id}/resources`);
  return data;
}

// Declarativo: o que não vem na lista deixa de estar atribuído ao connector.
export async function updateEdgeConnectorResources(id, payload) {
  const { data } = await api.put(`/edge-connectors/${id}/resources`, payload);
  return data;
}

/** Enfileira job de teste para o Edge puxar (antes do divert automático). */
export async function enqueueEdgeConnectorJob(id, payload) {
  const { data } = await api.post(`/edge-connectors/${id}/jobs`, payload);
  return data;
}

export async function updateExecutionMode(executionMode) {
  const { data } = await api.put('/accounts/execution-mode', {
    execution_mode: executionMode,
  });
  return data;
}

export async function listAccountLlmCredentials() {
  const { data } = await api.get('/accounts/llm-credentials');
  return data;
}

export async function saveAccountLlmCredential(provider, apiKey) {
  const { data } = await api.put(`/accounts/llm-credentials/${provider}`, {
    api_key: apiKey,
  });
  return data;
}

export async function deleteAccountLlmCredential(provider) {
  await api.delete(`/accounts/llm-credentials/${provider}`);
}
